import { render, staticRenderFns } from "./MapPointPicker.vue?vue&type=template&id=0bf502ee&"
import script from "./MapPointPicker.vue?vue&type=script&lang=ts&"
export * from "./MapPointPicker.vue?vue&type=script&lang=ts&"
import style0 from "./MapPointPicker.vue?vue&type=style&index=0&id=0bf502ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports